import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Beneficiario } from '../models/beneficiary.model';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BeneficiaryService {
 atualizarAlteracoesFuncionais(matricula:string,orgao:number) {
   return this.http.put<any[]>(`${environment.URL_API}/vinculo/alteracao-funcional/matricula/${matricula}/orgao/${orgao}`,{});
 }

  private urlServer = environment.URL_API;

  private readonly apiUrl = '/vinculo/pesquisa/vinculos';

  constructor(private http: HttpClient, private session: SessionService) {}

  getBeneficiarios(
    page: number,
    maxpage: number,
    filter: any
  ): Observable<{ total: number; results: Beneficiario[] }> {
    const token = this.session.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    const params = { page, maxpage, ...filter };

    return this.http.get<{ total: number; results: Beneficiario[] }>(
      this.urlServer + this.apiUrl,
      {
        headers,
        params,
      }
    );
  }

  getDadosPessoais(matricula: any, orgao: any): Observable<any> {
    const token = this.session.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.http.get<{ total: number; results: Beneficiario[] }>(
      this.urlServer +
        '/vinculo/dados-pessoais/matricula/' +
        matricula +
        '/orgao/' +
        orgao,
      {
        headers,
      }
    );
  }

  getDadosFuncionais(matricula: any, orgao: any): Observable<any> {
    const token = this.session.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.http.get<{ total: number; results: Beneficiario[] }>(
      this.urlServer +
        '/vinculo/dados-funcionais/matricula/' +
        matricula +
        '/orgao/' +
        orgao,
      {
        headers,
      }
    );
  }

  getAlteracoesFuncionais(matricula: any, orgao: any): Observable<any> {
    const token = this.session.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.http.get<{ total: number; results: Beneficiario[] }>(
      this.urlServer +
        '/vinculo/alteracao-funcional/matricula/' +
        matricula +
        '/orgao/' +
        orgao,
      {
        headers,
      }
    );
  }

  downloadAlteracoesFuncionaisRelatorio(
    matricula: string,
    orgaoId: number
  ): Observable<Blob> {
    const token = this.session.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      Accept: '*/*',
    });

    const body = { matricula, orgaoId };

    // IMPORTANTE: responseType 'blob' para receber PDF
    return this.http.post(
      `${this.urlServer}/pdf/quadro-alteracoes-funcionais`,
      body,
      { headers, responseType: 'blob' }
    );
  }

  uploadAlteracaoFuncionalDocumento(idOrigem: number, file: File) {
    const token = this.session.token;
    const matricula = this.session.beneficiario.matricula; // já usado em outras telas
    const idOrgao = this.session.beneficiario.orgao.id; // idem (deve ser o ID numérico)

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      // NÃO defina manualmente Content-Type para multipart. O browser define com boundary.
    });

    const params = new HttpParams()
      .set('matricula', String(matricula))
      .set('idOrgao', String(idOrgao))
      .set('idOrigem', String(idOrigem))
      .set('tipoDocumento', 'DOCUMENTO_ALTERACAO_FUNCIONAL');

    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(`${this.urlServer}/files/upload`, formData, {
      headers,
      params,
    });
  }

  deleteDocumentoPorHash(hash: string) {
    const token = this.session.token;
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    const params = new HttpParams().set('hash', hash);

    return this.http.delete(`${this.urlServer}/files`, { headers, params });
  }

  downloadDocumentoPorHash(hash: string) {
    const token = this.session.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: '*/*',
    });

    const params = new HttpParams().set('hash', hash);

    // observe: 'response' para acessar headers (Content-Disposition) e extrair filename
    return this.http.get(`${this.urlServer}/files/download`, {
      headers,
      params,
      responseType: 'blob',
      observe: 'response',
    });
  }
}
